import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M22 16v-.5c0-1.38-1.12-2.5-2.5-2.5S17 14.12 17 15.5v.5c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1zm-1 0h-3v-.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v.5zm-1.5-5c.17 0 .33.03.5.05V3.41c0-.89-1.08-1.34-1.71-.71L2.71 18.29c-.63.63-.19 1.71.7 1.71H14v-3c0-.92.42-1.74 1.07-2.3.38-2.1 2.22-3.7 4.43-3.7z"
}), 'NetworkLockedRounded');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/NetworkLockedRounded.js
// module id = 5023
// module chunks = 2